import { GenerateUrlUploadData } from '@/common/GenerateUrlUploadData';
import { DataResponse } from '@/common/Response';
import { UploadSignatureResponse } from '@/data/common/types';
import { UploadFilePayload } from '@/data/contact/types';
import {
  IProfile,
  UpdateProfilePayload,
  UpdateSignaturePayload,
  UploadAvatarPayload,
  UploadAvatarReturn,
} from '@/data/user/types';
import { UserProfile } from '@/models/user/UserProfile';
import { Api, ApiOptions } from '@/utils/api';

const userService = {
  getProfile: (params: any, options?: ApiOptions) => {
    return Api.post<DataResponse<UserProfile>>(
      '/api/v1/users/ids',
      params,
      options,
    );
  },
  getProfileMe: (options?: ApiOptions) => {
    return Api.get<DataResponse<IProfile>>('/api/v1/me', options);
  },

  uploadAvatar: (payload: UploadAvatarPayload, options?: ApiOptions) => {
    const formData = new FormData();
    formData.append('file', payload.file);

    return Api.post<UploadAvatarReturn>(
      '/api/v1/me/avatar',
      payload,
      options,
      formData,
    );
  },

  updateProfile: (payload: UpdateProfilePayload, options?: ApiOptions) => {
    return Api.put<DataResponse<boolean>>('/api/v1/me', payload, options);
  },

  updateSignature: (payload: UpdateSignaturePayload, options?: ApiOptions) => {
    return Api.patch<DataResponse<boolean>>(
      '/api/v1/users/signature',
      payload,
      options,
    );
  },

  signedUpload: (payload: UploadFilePayload, options?: ApiOptions) => {
    return Api.post<DataResponse<UploadSignatureResponse>>(
      `/api/v1/users/signature/signed-upload`,
      payload,
      options,
    );
  },

  generateUrlUploadMyAvatar: (
    params: { contentType: string },
    options?: ApiOptions,
  ) => {
    return Api.post<DataResponse<GenerateUrlUploadData>>(
      '/api/users/avatar',
      params,
      options,
    );
  },
  generateUrlUploadMyImage: (
    params: { contentType: string; target: string },
    options?: ApiOptions,
  ) => {
    return Api.post<DataResponse<GenerateUrlUploadData>>(
      '/api/users/image',
      params,
      options,
    );
  },
  removeMyAvatar: (options: ApiOptions = {}) => {
    return Api.patch<DataResponse<string>>('/api/users/avatar', {}, options);
  },
  removeMyImage: (params: { target: string }, options?: ApiOptions) => {
    return Api.patch<DataResponse<string>>('/api/users/image', params, options);
  },
};

export default userService;
